import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const cancelAdminSensorOrder = async (orderId) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `admin/renolog/sensor-orders/${orderId}/cancel`,
    body: {},
    //isLocalApiRequest: true,
  });
  const response = await axios(signedRequest);
  return response.data;
};
